import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppShell } from "./components/shell/AppShell";
import { DeskPage } from "./components/desk/DeskPage";
import { Playbook } from "./components/Playbook";
import { Trades } from "./components/Trades";
import { PerformanceDashboard } from "./components/PerformanceDashboard";
import { SettingsPage } from "./components/SettingsPage";
import { GamesPage } from "./components/games/GamesPage";
import { AuthGate } from "./components/auth/AuthGate";

export function App() {
	return (
		<BrowserRouter>
			<AuthGate>
			<AppShell>
				<Routes>
					<Route path="/" element={<DeskPage />} />
					<Route path="/playbook" element={<Playbook />} />
					<Route path="/trades" element={<Trades />} />
					<Route path="/performance" element={<PerformanceDashboard />} />
					<Route path="/games" element={<GamesPage />} />
					<Route path="/settings" element={<SettingsPage />} />
				</Routes>
			</AppShell>
			</AuthGate>
		</BrowserRouter>
	);
}
